/** M4A1. 5.56 mm carbine, the all-rounder: tightest sighted cone of the automatics. */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const M4A1 = {
  id: 'm4a1',
  label: 'M4A1',
  classId: 'rifle',
  caliber: '5.56x45 mm',
  fireMode: 'auto',
  roundsPerMinute: 750,
  magSize: 30,
  reserveAmmo: 150,
  reloadSeconds: 2.4,
  emptyReloadSeconds: 3.1,
  reloadStyle: 'magazine',
  damage: 33,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 60, zeroMetres: 300, minScale: 0.5 },
  pellets: 1,
  adsSpreadMoa: 3,
  hipSpreadMoa: 120,
  bloomMoaPerShot: 7,
  bloomMoaCap: 55,
  bloomDecayMoaPerSecond: 80,
  moveSpreadMoaPerMps: 26,
  crouchSpreadScale: 0.6,
  airborneSpreadMoa: 90,
  // Four hard up the middle, a lean left, then a lazy sweep back right.
  recoilPattern: [
    { pitch: 0.9, yaw: 0.05 },
    { pitch: 0.82, yaw: -0.1 },
    { pitch: 0.78, yaw: -0.22 },
    { pitch: 0.7, yaw: -0.3 },
    { pitch: 0.64, yaw: -0.18 },
    { pitch: 0.6, yaw: 0.06 },
    { pitch: 0.56, yaw: 0.24 },
    { pitch: 0.54, yaw: 0.32 },
    { pitch: 0.5, yaw: 0.2 },
    { pitch: 0.48, yaw: -0.04 },
    { pitch: 0.46, yaw: -0.2 },
    { pitch: 0.44, yaw: -0.12 },
  ],
  recoilResetSeconds: 0.3,
  recoilRecoveryPerSecond: 6.5,
  adsFovDegrees: 45,
  adsSeconds: 0.22,
  adsSensitivityScale: 0.65,
  muzzleVelocity: 880,
} as const satisfies WeaponSpec;
